export enum CUSTOM_FORM_DIALOG_FIELD_TYPE {
    text,
    areaText,
    number,
    select,
    slider,
    multiSelect
}

export const MAXIUM_WARNING_POINT = 300